import React from 'react'
import { CSidebar, CSidebarNav, CNavItem, CNavLink, CBadge } from '@coreui/react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

const AppNavLat = ({ items, base }) => {
  const location = useLocation()
  const navLink = (name, badge) => {
    return (
      <>
        {name && name}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    )
  }

  const navItem = (item, index) => {
    const { name, classname, badge, ...rest } = item
    const Component = CNavItem
    return (
      <Component
        {...(!rest.items && {
          component: CNavLink,
        })}
        href={base + rest.to}
        key={'sub_' + index}
        className={
          location.pathname === base + rest.to ? 'active menu_terciario' : 'menu_terciario'
        }
        {...rest}
      >
        {navLink(name, badge)}
      </Component>
    )
  }
  const navGroup = (item, index) => {
    const { name, classname, to, ...rest } = item
    const Component = CNavItem
    return (
      <Component
        idx={String(index)}
        key={'sub_' + index}
        toggler={navLink(name)}
        visible={location.pathname.startsWith(to)}
        className={classname}
        {...rest}
      >
        {item.nodos?.map((item, index) =>
          item.nodos ? navGroup(item, index) : navItem(item, index),
        )}
      </Component>
    )
  }

  return (
    <>
      <CSidebar>
        <CSidebarNav>
          <React.Fragment>
            {items &&
              items.map((item, index) =>
                item.nodos ? navGroup(item, index) : navItem(item, index),
              )}
          </React.Fragment>
        </CSidebarNav>
      </CSidebar>
    </>
  )
}

AppNavLat.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  base: PropTypes.string.isRequired,
}

export default React.memo(AppNavLat)
